import naja from 'naja';
import netteForms from 'nette-forms';
import '../../../../www/src/common/js/consent';
import '../../../../www/src/common/components/loader/loader';
import './carousel/carousel';
import { getFirstSearchInput, initSearchBoxes } from './searchboxes';
import './modal';
import { initCustomFileInputs } from './customFile';
import { portalText } from './i18n';
import { allowPhoneFormFallback, destroyIntlPhones, initializeIntlPhones, normalizeIntlPhonesForSubmit } from './intlPhone';
import '../scss/index.scss';

netteForms.showFormErrors = (form, errors) => {
    const messages = errors.map(error => error.message).join('<br>');
    let container = form.querySelector('.form-errors');

    if (!container) {
        container = document.createElement('div');
        container.className = 'form-errors';
        form.prepend(container);
    }

    container.innerHTML = messages;
    container.hidden = errors.length === 0;
    errors[0]?.element?.focus();
};

netteForms.initOnLoad();
naja.formsHandler.netteForms = netteForms;

naja.addEventListener('success', event => {
    const redirectUrl = event.detail.payload?.redirectUrl;
    if (redirectUrl) {
        void naja.makeRequest('GET', redirectUrl, null, {history: true});
    }
});

naja.addEventListener('complete', () => initializeDynamicUi(document));
naja.snippetHandler.addEventListener('beforeUpdate', event => destroyIntlPhones(event.detail.snippet));
naja.snippetHandler.addEventListener('afterUpdate', event => initializeDynamicUi(event.detail.snippet));

onReady(() => {
    initializeDynamicUi(document);
    bindDelegatedInteractions();
    naja.initialize();
});

function onReady(callback) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, {once: true});
    } else {
        callback();
    }
}

function initializeDynamicUi(root) {
    initSearchBoxes(root);
    initCustomFileInputs(root);
    initializeIntlPhones(root);
    initializeSpamTraps(root);
}

function initializeSpamTraps(root) {
    root.querySelectorAll('.fsbch').forEach(element => {
        element.hidden = true;
        const input = element.querySelector('input');
        if (input) {
            input.value = 'pr' + 'ác' + 'e';
        }
    });
}

function bindDelegatedInteractions() {
    document.addEventListener('submit', event => {
        if (event.target instanceof HTMLFormElement) {
            let shouldBlock = false;
            try {
                shouldBlock = !normalizeIntlPhonesForSubmit(event.target);
            } catch {
                allowPhoneFormFallback(event.target);
            }
            if (shouldBlock) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        }
    }, true);

    document.addEventListener('click', event => {
        const stateToggle = event.target.closest('.state-dropdown-toggle');
        if (stateToggle) {
            const parent = stateToggle.closest('.state-dropdown-wrap');
            document.querySelectorAll('.state-dropdown-wrap.open').forEach(element => {
                if (element !== parent) {
                    element.classList.remove('open');
                }
            });
            parent?.classList.toggle('open');
            return;
        }

        if (event.target.closest('.more-foot-links a')) {
            event.preventDefault();
            document.querySelector('.footer-links .offers')?.classList.toggle('expanded');
            return;
        }

        const seoToggle = event.target.closest('.seo-text-btns a');
        if (seoToggle) {
            event.preventDefault();
            seoToggle.closest('.seo-text')?.classList.toggle('expand');
            return;
        }

        const job = event.target.closest('.comp__jobs .job');
        if (job && !job.querySelector('.comp__badges .displayed')) {
            job.classList.add('mute');
            let badges = job.querySelector('.comp__badges');
            if (!badges) {
                badges = document.createElement('span');
                badges.className = 'comp__badges';
                job.prepend(badges);
            }
            const displayed = document.createElement('span');
            displayed.className = 'badge badge-indigo displayed';
            displayed.textContent = portalText('displayed');
            badges.prepend(displayed);
        }

        const showMore = event.target.closest('.show-more-jobs');
        if (showMore) {
            event.preventDefault();
            showMore.hidden = true;
            document.querySelector('.job-content .jobs-box')?.classList.add('show');
            return;
        }

        if (event.target.closest('.job-content .job-apply')) {
            event.preventDefault();
            const modal = document.querySelector('.modal.open');
            const form = document.querySelector('#frm-jobForm');
            const targetTop = modal
                ? (modal.querySelector('.job-content')?.offsetHeight ?? 0) + (modal.querySelector('.job-sidebar .top')?.offsetHeight ?? 0) + 50
                : Math.max(0, (form?.getBoundingClientRect().top ?? 0) + window.scrollY - 15);
            (modal ?? window).scrollTo({top: targetTop, behavior: 'smooth'});
            window.setTimeout(() => document.querySelector('#frm-jobForm-name')?.focus(), 500);
            return;
        }

        if (event.target.closest('.focusSearchbox')) {
            event.preventDefault();
            window.scrollTo({top: 0, behavior: 'smooth'});
            window.setTimeout(() => {
                const input = getFirstSearchInput();
                input?.focus();
                input?.click();
            }, 500);
        }
    });
}
